const selector = '[data-char-wave]';
const split = new WeakSet();

/**
 * Wraps each character of the element's own text in a span, so CSS can run a
 * blur-and-fade wave through them left to right on hover. Child elements (an
 * icon) are left alone, and the characters sit in one wrapper, so a flex
 * parent's gap doesn't land between letters. Screen readers get the text once from a hidden label;
 * the character spans are hidden from them, so the word isn't spelled out.
 *
 * The delay is spread over `--char-wave-count`, so the whole wave takes the
 * same time (0.8 s) whatever the length of the text.
 *
 * The wave runs when the element itself is hovered; with
 * `data-char-wave="group"` it runs when its closest `[data-char-wave-group]`
 * ancestor is, so a whole card can play its link's wave.
 */

function splitChars(element) {
  const textNodes = [...element.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE);

  const count = textNodes.reduce((sum, node) => sum + [...node.textContent.trim()].length, 0);

  let index = 0;

  textNodes.forEach((node) => {
    const text = node.textContent.trim();

    if (!text) return;

    const wrapper = document.createElement('span');
    const label = document.createElement('span');

    wrapper.className = 'char-wave__text';
    label.className = 'char-wave__label';
    label.textContent = text;
    wrapper.append(label);

    [...text].forEach((char) => {
      const span = document.createElement('span');

      span.className = 'char-wave__char';
      span.textContent = char;
      span.setAttribute('aria-hidden', 'true');
      span.style.setProperty('--char-wave-index', index++);
      span.style.setProperty('--char-wave-count', count);
      wrapper.append(span);
    });

    node.replaceWith(wrapper);
  });
}

/** Idempotent: an element is split once, however often this runs. */

export function initCharWave(scope = document) {
  scope.querySelectorAll(selector).forEach((element) => {
    if (split.has(element)) return;

    split.add(element);
    splitChars(element);
  });
}

document.addEventListener('DOMContentLoaded', () => initCharWave());
